<template>
  <div>
    <!-- <el-button
      type="primary"
      icon="el-icon-plus"
      @click="setUserinfoDetailDialogVisible = true"
      >添加</el-button
    > -->
    <el-dialog
      :visible="userinfoDetailDialogVisible"
      title="修改 gas和阈值 配置信息"
      width="820px"
      @close="closeDialog"
    >
      <el-form :model="changeForm" ref="form"   label-width="160px">
        <el-form-item label="币种：" >
          <el-input v-model="changeForm.coin" disabled></el-input>
        </el-form-item>
        <el-form-item label="币种的链：">
          <el-input v-model="changeForm.chain" disabled></el-input>
        </el-form-item>
        
        <el-form-item label="转冷阀值：" >
          <el-input v-model="changeForm.transferColdValue"></el-input>
        </el-form-item>
        <!-- <el-form-item label="是否gas费币：">
          <el-select v-model="changeForm.state" disabled>
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="注册来源：">
          <span>{{ changeForm.__registerFrom }}</span>
        </el-form-item>
        <el-form-item label="用户ID：">
          {{ changeForm.id }} <el-button size="small" type="danger" @click="resetLoginPassword(changeForm.id)">重置登录密码</el-button>
        </el-form-item>
        <el-form-item label="用户账号：">
          {{ changeForm.username }}
        </el-form-item>
        <el-form-item label="用户状态：">
          <span>{{
            changeForm.__userStatus && changeForm.__userStatus.text
          }}</span>
        </el-form-item>
        <el-form-item label="实名认证：">
          <span>
            {{ changeForm.__userStatus && changeForm.__idNoStatus.text }}</span
          >
        </el-form-item>
        <el-form-item label="谷歌认证：">
          <span>{{
            changeForm.__googleSecurityStatus &&
              changeForm.__googleSecurityStatus.text
          }}</span>
        </el-form-item>
        <el-form-item label="银行卡绑定状态：">
          <span>{{
            changeForm.__bankAuthStatus && changeForm.__bankAuthStatus.text
          }}</span>
        </el-form-item>
        <el-form-item label="是否迁移用户：">
          <span v-if="changeForm.oldOrNew === 'old'">是</span>
          <span v-else>否</span>
        </el-form-item>
        <el-form-item label="冻结状态：">
          <span v-if="changeForm.userStatus == 0">否</span>
          <span v-else-if="changeForm.userStatus == -1"
            >是（管理员ID：{{ changeForm.adminId }}，原因：{{
              changeForm.content
            }}）</span
          >
        </el-form-item>
        <el-form-item label="电话号码(区号必选)：">
          <el-input v-model="changeForm.tel">
            <el-select v-model="changeForm.telCountryCode" slot="append">
              <el-option
                v-for="(n, index) in countryCodeList"
                :key="index"
                :label="`+${n.code}`"
                :value="n.code"
              >
              </el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="邮箱：">
          <el-input v-model="changeForm.email"></el-input>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'updatedialog',
props:['selected','page','size'],
  data() {
    return {
      changeForm: {
        chain:'',
        coin:'',
        transferColdValue:'',
        state:null,
      },
      statusOptions:[
        { value: 0, label: '是' },
        { value: 1, label: '不是' },
        
      ],
      rules:{
        telCountryCode:[{required:true,message:'区号必选',trigger:blur}]
      }
      
      
    };
  },
  watch: {
    userinfoDetail(val, oldVal) {
      if (val !== oldVal) {
        this.changeForm = { ...val };
      }
    }
  },
  computed: {
    ...mapState('gas', [
      'userinfoDetail',
      'userinfoDetailDialogVisible',
      'countryCodeList',
      'pagination','queryType'
    ]),
    ...mapGetters('gas', ['userList'])
  },
  methods: {
    ...mapMutations('gas', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail'
    ]),
    ...mapActions('gas', ['updatInfo','list', 'coutryCode','resetPassword','updateGasDto','getGasList']),
    closeDialog() {
      this.setUserinfoDetailDialogVisible(false);
    },
    handleSave() {
      this.updateGasDto({...this.changeForm}).then(res=>{
        if(res.code==0){
          this.$message.success('修改成功')
          this.setUserinfoDetailDialogVisible(false)
          this.getGasList({page:this.page,size:this.size,coin:this.selected})
        }
      })
    },
    resetLoginPassword(id){
      this.resetPassword({userId:id}).then(()=>{
        this.$message.success('重置成功！');
      })
    }
  },
  created() {
    this.coutryCode();
  }
};
</script>

<style lang="less" scoped>
::v-deep.el-select {
  .el-input__inner {
    width: 100px;
  }
}
</style>
